export default __webpack_public_path__ + "static/media/applePay.0bd2bdcc.svg";